import React, { useMemo, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Loading } from "go-core/components/Loading";
import {
	PaymentMethodApi,
	PaymentMethodIntegration,
	PaymentMethodSettingApi,
	PaymentMethodTPayPaymentsTypeApi,
} from "../../../../../../../../../../../services/Api/Organization/types";
import { getPaymentMethodOnlinePayments } from "../../../utils";
import { findPaymentMethodSettingIndexForInput, getIntegrationName } from "../../../utils/onlinePayments";

interface Props {
	show: boolean;
	onHide: () => void;
	settings: PaymentMethodSettingApi[];
	integration: PaymentMethodIntegration;
	form: UseFormReturn<PaymentMethodApi>;
	paymentsTypes?: PaymentMethodTPayPaymentsTypeApi[];
}

const PaymentMethodIntegrationModalForm = ({ show, onHide, form, integration, settings, paymentsTypes }: Props) => {
	const { t } = useTranslation();
	const { setValue } = form;
	const paymentMethods = getPaymentMethodOnlinePayments();
	const [formSettings, setFormSettings] = useState<PaymentMethodSettingApi[]>(settings);

	const handleOnChangePaymentMethod = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const newSettings = JSON.parse(JSON.stringify(formSettings));
		newSettings[index].value = event.target.checked;
		setFormSettings(newSettings);
	};

	const drawPaymentMethods = useMemo(() => {
		return paymentMethods.map((paymentMethod) => {
			const index = findPaymentMethodSettingIndexForInput(settings, paymentMethod);
			const paymentType = (paymentsTypes || []).find(({ type }) => type.toString() === paymentMethod.toString());
			const visible = paymentType ? paymentType.is_available : false;

			if (visible) {
				const translationKey = `enums.payment_method.online_payment.${paymentMethod.replace("_ENABLED", "")}`;
				return (
					<div className="form-group" key={paymentMethod}>
						<Form.Check
							type="switch"
							label={t(`${translationKey}_LABEL`)}
							checked={formSettings[index].value === "true" || formSettings[index].value === true}
							onChange={(event) => handleOnChangePaymentMethod(event, index)}
						/>
						<div style={{ paddingLeft: "0.5em" }}>
							<Form.Text muted>{t(`${translationKey}_HELP_TEXT`)}</Form.Text>
						</div>
					</div>
				);
			}

			return <></>;
		});
	}, [paymentMethods]);

	const onSubmit = () => {
		setValue("settings", formSettings, { shouldDirty: true });
		onHide();
	};

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>{getIntegrationName(integration, t)}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{!paymentsTypes ? <Loading /> : <div className="d-flex flex-column gap-1">{drawPaymentMethods}</div>}
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onSubmit}>{t("lib:common.action.save")}</Button>
				<Button variant="light" onClick={onHide}>
					{t("lib:common.action.cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default PaymentMethodIntegrationModalForm;
